/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
    createEntityListActions,
    createEntityListState,
    createEntityMapActions,
    createEntityMapState,
    createGenericStore
} from "@microsoft/shifts-experiences-shared";

import { UsersActions } from "./UsersActions";
import { UsersState } from "./UsersState";

/**
 * The users store and actions.
 */
const { actions, store } = createGenericStore<UsersState, UsersActions>({
    actionsCreators: [createEntityListActions, createEntityMapActions],
    namespace: "UsersStore",
    statesCreators: [createEntityListState, createEntityMapState]
});

/**
 * The store which holds the users info map.
 */
export const UsersStore = store;

/**
 * The actions for the users store.
 */
export const usersActions = actions;
